/* eslint-disable */
import { Weight } from 'lucide-react';

export const parentTabs = [
	{
		id: 1,
		// value: 'ISSUED',
		header: 'Issued Summary',
	},
	{
		id: 2,
		value: 'PRODUCED',
		header: 'Produced Summary',
	},
	{
		id: 3,
		value: 'DISPATCHED',
		header: 'Dispatch Summary',
	},
	{
		id: 4,
		value: 'WASTAGE',
		header: 'Wastage Summary',
		showCustomer: 'naga',
	},
];

export const subParentTabs = {
	1: [
		{
			id: 1,
			value: 'ISSUED',
			header: 'Central Kitchen',
		},
		{
			id: 2,
			value: 'INDENT',
			header: 'Restaurant Indent',
			showCustomer: 'a2b',
		},
	],
};
export const meals = [
	{
		id: -999,
		value: 'all',
		header: 'All',
	},
	{
		id: 55,
		value: 'breakfast',
		header: 'BreakFast',
	},
	{
		id: 56,
		value: 'lunch',
		header: 'Lunch',
	},
	{
		id: 57,
		value: 'snacks',
		header: 'Snacks',
	},
	{
		id: 54,
		value: 'dinner',
		header: 'Dinner',
	},
	{
		id: 999,
		value: 'allDay',
		header: 'All Day',
	},
];

export const tabs = [
	{
		id: 'weight', label: 'Weight', icon: <Weight size={12} />,
	},
	{
		id: 'cost', label: 'Cost', icon: '₹',
	},
	{
		id: 'percentage', label: 'Percentage', icon: '%',
	},
];

export const tableTabsIssuedSummary = [
	{
		id: 1,
		value: 'products',
		label: 'Finished Goods(FG)',
		labelA2b: 'Products(FG)',
	},
	{
		id: 2,
		value: 'rawMaterials',
		label: 'Raw Materials(RM)',
		labelA2b: 'Raw Materials(RM)',
	},
];

export const tableTabsProducedSummary = [
	{
		id: 1,
		value: 'outlets',
		label: 'Producing For',
		labelA2b: 'Outlets',
	},
	{
		id: 2,
		value: 'products',
		label: 'Finished Goods(FG)',
		labelA2b: 'Products(FG)',
	},
	{
		id: 3,
		value: 'sfg',
		label: 'SFG',
		showCustomer: 'naga',
	}
];
export const tableTabsDispatchedSummary = [
	{
		id: 1,
		value: 'outlets',
		label: 'Outlets',
	},
];

export const tableTabsRestaurantIndent = [
	{
		id: 1,
		value: 'section',
		label: 'Sections',
	},
];
export const tableTabsWastageSummary = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process Wise',
	},
	{
		id: 2,
		value: 'reasonWise',
		label: 'Reason Wise',
	},
];
